import React, { FC, useEffect, useRef, useState } from "react";
import Slick from "react-slick";
import "./slider.scss";
import HtmlRender from "../HtmlRender";
import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { RootState } from "../../../store";
import { BRANDS, COUNTRY } from "../../../constants/app";
import { setNowShowingLoader, setQuickFilter } from "../../../store/films/action";
import { downloadFile } from "../../../utils/helper";

interface ISliderProps {
  data?: Array<any>;
  arrows?: boolean;
  fade?: boolean;
  isDotsNeeded?: boolean;
  className?: string;
}

const Slider: FC<ISliderProps> = ({
  data,
  arrows = true,
  fade = true,
  isDotsNeeded = false,
  ...props
}) => {
  const slideRef = useRef<any>();
  let settings = {
    className: "",
    centerMode: true,
    centerPadding: "0px",
    dots: isDotsNeeded,
    lazyload: true,
    infinite: true,
    speed: 300,
    slidesToShow: 1,
    autoplay: true,
    autoplaySpeed: 4000,
    cssEase: "linear",
    // fade: fade,
    slidesToScroll: 1,
    initialSlide: 1,
    slidesPerRow: 1,
    swipeToSlide: true,
    adaptiveHeight: true,
    arrows: arrows,
    appendDots: (dots: any) => <ul>{dots}</ul>,
    customPaging: (i: any) => (
      <div className="ft-slick__dots--custom">
        <div className="loading" />
      </div>
    ),
  };

  const { currentCinema, brandId, countryId, quickFilters } = useSelector((state: RootState) => ({
    currentCinema: state.applicationReducer.currentCinema,
    brandId: state.applicationReducer.brandId,
    countryId: state.applicationReducer.countryId,
    quickFilters: state.filmsReducer.quickFilters
  }));

  const navigate = useNavigate();
  const dispatch = useDispatch();
  useEffect(() => {
    if (slideRef) {
      slideRef.current?.slickGoTo(0);
    }
  }, [data]);

  const openLink = (slides: any) => {
    dispatch(setNowShowingLoader(false));
    dispatch(setQuickFilter({
      ...quickFilters,
      tempDate: quickFilters.date,
      format: null,
      movie: null,
      session: null,
      date: null,
    }))
    if (!slides.bannerlink) {
      return;
    }

    if (brandId === BRANDS.AU) {
      if (slides.bannerlink.includes("https://")) {
        window.open(slides.bannerlink, "_self");
      } else {
        navigate(slides.bannerlink);
      }
    } else {
      if (slides.urlLinkType) {
        if (slides.urlLinkType === "external") {
          if (slides.bannerlink.includes("https://") || slides.bannerlink.includes("http://")){
            window.open(slides.bannerlink, "_blank");
          }else{
             navigate(`/${currentCinema?.alias}${slides.bannerlink}`);
          }
        } else if (slides.urlLinkType === "internal") {
          navigate(
            `/${currentCinema?.alias}/${slides.bannerlink.replace("//", "/")}`
          );
        } else if (slides.bannerlink.includes("https://") || slides.bannerlink.includes("http://")) {
          window.open(slides.bannerlink, "_blank");
        } else {
          navigate(`/${currentCinema?.alias}/${slides.bannerlink}`);
        }
      }
    }
  };

  const openButtonLink = (slide: any) => {

    if (!slide.buttonLink) {
      return;
    }
    
    if (slide.urlLink && slide.urlLink === 'file') {
      downloadFile(slide.buttonLink, '_blank');
    } else {
      dispatch(setNowShowingLoader(false));
      dispatch(setQuickFilter({
        ...quickFilters,
        tempDate: quickFilters.date,
        format: null,
        movie: null,
        session: null,
        date: null,
      }))
      if (slide.buttonLink.includes("https://") || slide.buttonLink.includes("http://")) {
        window.open(slide.buttonLink, "_blank");
      } else {
        navigate(`/${currentCinema?.alias}${slide.buttonLink}`);
      }
    }
  }

  return (
    <div className={`banner_wrap ${!isDotsNeeded ? 'no-arrow' : ''} ${countryId === COUNTRY.CON ? 'consolidated' : countryId === COUNTRY.AFC ? 'angelika-flim-center' : ''}`}>
      <Slick {...settings}
       {...props} 
      ref={slideRef} 
      >
        {data?.map((slide, index) => {
          return (
            <>
              <div key={index} className={`banner-image ${slide?.textPosition}`}>

                {slide?.showBannerInfo === 0 ? (
                  <a key={index} onClick={() => openLink(slide)}>
                    {slide?.imageUrl ? (
                      <img
                        className="d-none d-md-block"
                        src={slide.imageUrl}
                        alt={slide.title}
                      />
                    ) : null}
                    {slide?.mobileImageUrl ? (
                      <img
                        className="d-block d-md-none"
                        src={slide.mobileImageUrl}
                        alt={slide.title}
                      />
                    ) : null}
                  </a>
                ) : (
                  <>
                    {slide?.imageUrl ? (
                      <img
                        className="d-none d-md-block"
                        src={slide.imageUrl}
                        alt={slide.title}
                      />
                    ) : null}
                    {slide?.mobileImageUrl ? (
                      <img
                        className="d-block d-md-none"
                        src={slide.mobileImageUrl}
                        alt={slide.title}
                      />
                    ) : null}
                  </>
                )}
              </div>
              {slide?.showBannerInfo === 1 && brandId === BRANDS.AU ? (
                <div className={`slide-content ${slide.addGradient === 1 ? 'add-gradient' : ''}`}>
                  <div className="col_left">
                    {slide.ratingIcon ? (
                      <div className="rating_icon">
                        <img
                          src={slide.ratingIcon}
                          alt={slide.ratingName}
                        />
                      </div>
                    ) : null}
                    {slide?.addHeader === 1 ? (
                      <div
                        className={`title ${slide.textColor === "black" ? "text_black" : ""
                          }`}
                      >
                        {slide?.headerText}
                      </div>
                    ) : null}
                    {slide.description ? (
                      <div
                        className={`description ${slide.textColor === "black" ? "text_black" : ""
                          }`}
                      >
                        <HtmlRender content={slide.description} />
                      </div>
                    ) : null}
                  </div>
                  <div className="col_right">
                    {slide.buttonText ? (
                      <div className="banner-btn">
                        <a href={slide.buttonLink} className="white_btn">
                          {slide.buttonText}
                        </a>
                      </div>
                    ) : null}
                  </div>
                </div>
              ) : brandId === BRANDS.US &&
                ((slide?.buttonText &&
                  slide?.buttonLink) ||
                  slide?.description || 
                  slide?.icon ||
                  slide?.mobileIcon ||
                  (slide?.addHeader && slide?.headerText)
                ) ? (

                <div className={`slide-content ${slide.addGradient === 1 ? 'add-gradient' : ''}`} onClick={() => openLink(slide)}>

                  <div className="banner-content">
                    <div className="left-wrap">
                      {slide.icon ? (
                      <div className="header_icon d-none d-md-block">
                        <img
                          src={slide.icon}
                          alt={slide.title}
                        />
                      </div>
                    ) : null}
                      {slide.mobileIcon ? (
                      <div className="header_icon d-md-none d-block">
                        <img
                          src={slide.mobileIcon}
                          alt={slide.mobileIcon}
                        />
                      </div>
                    ) : null}

                      <div className="left">
                        {slide?.addHeader === 1 ? (
                          <div
                            className="title"
                          >
                            {slide?.headerText}
                          </div>
                        ) : null}

                        {slide.description ? (
                          <div
                            className="description"
                          >
                            <HtmlRender content={slide.description} />

                          </div>
                        ) : null}
                      </div>
                    </div>
                    <div className="right">
                      {slide.buttonText ? (
                        <div className="banner-btn">
                          <a className="tkt-btn" onClick={(e) => {
                             e.stopPropagation();
                            openButtonLink(slide)
                           }}>
                            {slide.buttonText}
                          </a>
                        </div>
                      ) : null}
                    </div>
                  </div>

                </div>


              ) : null}
            </>
          );
        })}
      </Slick>
    </div>
  );
};

export default Slider;
